import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  cancelConfiguration, setActiveStep, preSaveConfiguration, removeSoftwareLicence, setSoftwareLicenceQuantity,
  setLicenseModel,
  updateMsxSoftwareLicenseReferences,
  addSoftwareLicences,
  addSoftwareLicencesWithNavigation,
  clearSoftwareLicenses,
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, softwareStepsConfig, LICENSE_MODELS, SUBSTITUTION_TYPE_REPLACE } from '../../../constants';
import { getSoftwareStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import Configuration from '../../../models/Configuration';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration, unsetLicenseSelectorId } from '../../../utils/app-starter';
import ApplicationFullHeader from '../../../components/application_full_header';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import Button from '../../../atoms/button';
import { getKnowMoreLinks, getLicenceCategories } from './ducks';
import { showNotificationWithButton } from '../../notification/ducks';
import MsxIcons from '../../msx-icons';
import { resetCBRSelectedItems, setCBRSelectedItems } from '../../call-by-range/ducks';
import { logDeleteCBRFilterEvent } from '../../../utils/analytics-logger';
import Notification from '../../notification';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../../color-constants';
import LicenseSelectorPackageSummary from '../../../components/software_licence/license_selector_package_summary';
import { buildLicenseGroups } from '../../../utils/software-licenses';
import LicenceSelectorScreenV2Content from '../../../components/software_licence/licence_selector_screen_v2_content';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #F4F4F4;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    padding: 0px;
  `}
`;

const ApplicationWrapper = styled.div`
  position: relative;
  display: flex;
  ${() => appConfiguration.launchFromScript === false ? 'flex: 1 1 0px;' : ''}
  overflow-y: auto;
  scroll-behavior: smooth;
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 40px;
  flex: 1 1 0px;
  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 800px) {
    padding: 0px 16px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-top: 20px;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  margin-bottom: 50px;
  @media (max-width: 800px) {
    margin-bottom: 40px;
  }
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  z-index: 30;
  background-color: white;
  border-top: 2px solid #EDEDED;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const TitleAndModelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px 40px 0px 40px;

  @media (max-width: 800px) {
    padding: 0px 16px 0px 16px;
  }
`;

const LicenseModelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const LicenseModelButtonsWrapper = styled.div`
  display: flex;
  margin-top: 10px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileLicenseModelButtonsWrapper = styled.div`
  display: none;
  margin-top: 10px;

  @media (max-width: 800px) {
    display: flex;
  }
`;

const LicenseModelButtonWrapper = styled.div`
  :not(:first-of-type) {
    --qds-control-border-radius-top-left: 0px;
    --qds-control-border-radius-bottom-left: 0px;
  }

  :not(:last-of-type) {
    --qds-control-border-radius-top-right: 0px;
    --qds-control-border-radius-bottom-right: 0px;
  }
`;

const OutdatedLicenseModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OutdatedLicenseModalLabel = styled.span`
  margin-bottom: 10px;
`;

const OutdatedLicenseModalRowLabel = styled.span`
  margin-bottom: 5px;
`;

const StepTitle = styled.span`
  color: black;
  font-size: 20px;
  font-weight: 700;
`;

const StepSubtitle = styled.span`
  color: #333333;
  font-size: 16px;
  font-weight: 400;
  margin-top: 5px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const DisplayGroupTitlesWrapper = styled.div`
  overflow: auto;
  box-shadow: 0px 2px 4px 0px #00000005;
  box-shadow: 0px 1px 6px -1px #00000005;
  box-shadow: 0px 1px 2px 0px #00000008;
  margin-top: 10px;
`;

const DesktopDisplayGroupTitlesWrapper = styled(DisplayGroupTitlesWrapper)`
  display: flex;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileDisplayGroupTitlesWrapper = styled(DisplayGroupTitlesWrapper)`
  display: none;
  @media (max-width: 800px) {
    display: flex;
  }
`;

const DisplayGroupItem = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const DisplayGroupLabel = styled.div`
  font-size: 16px;
  font-weight: 400;
  padding: 10px;
  color: #000000;

  ${props => props.$selected ? 'font-weight: 700;' : ''}

`;

const SelectionBar = styled.div`
  display: flex;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  border-radius: 8px;

  visibility: hidden;
  height: 5px;

  ${props => props.$selected ? 'visibility: visible;' : ''}
`;

const Link = styled.span`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
  :hover {
    text-decoration: underline;
  }
  margin-top: 10px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const LicenseBomButton = styled.div`
  position: absolute;
  bottom: -20px;
  right: 0px;
  z-index: 10;
  display: flex;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding: 10px 20px 10px 10px;
  transition: transform 250ms;
  transform: translateX(calc(100% - 40px)) translateY(100%);
  cursor: pointer;
  background-color: ${SECONDARY_COLOR};
  background-color: var(--se-primary, ${SECONDARY_COLOR});
  color: white;
  color: var(--se-primary-contrast, white);
  :hover {
    transform: translateY(100%);
  }
`;

const BomButtonLabel = styled.span`
  font-size: 18px;
  font-weight: 400;
  margin: 0px 10px;
`;

const PackageSummaryPositionner = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 301;
  ${props => (props.$show ? '' : 'pointer-events: none;')}
`;

const PackageSummaryBackground = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: black;

  opacity: ${props => (props.$show ? 0.5 : 0)};
  ${props => (props.$show ? '' : 'pointer-events: none;')}
  transition: opacity 250ms;
`;

const PackageSummaryWrapper = styled.div`
  position: absolute;
  right: 0px;
  top: 10px;
  bottom: 10px;
  display: flex;
  min-width: 410px;
  width: 410px;
  max-width: 410px;
  transform: ${props => props.$show ? 'translateX(0%)' : 'translateX(100%)'};
  transition: transform 250ms;


  @media (max-width: 800px) {
    min-width: unset;
    width: unset;
    max-width: 95%;
  }
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

class LicenceSelectorScreenV2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDesktop: window.innerWidth > 800,
      licenseDisplayGroups: [],
      scopedLicences: {},
      availableLicenseModel: {},
      licencesLoading: false,
      selectedDisplayGroup: null,
      showPackageSummary: false,
      mobileSelectedLicenseDisplayGroup: null,
      knowMoreLinksMap: {}
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  extractAvailableSelectorIds = (licenseDisplayGroups) => {
    const response = {};

    for (const licenseDisplayGroup of licenseDisplayGroups) {
      for (const subGroup of [...licenseDisplayGroup.subGroups]) {
        for (const type of [...subGroup.comparatorTypes]) {
          response[type.licenseTypesKey] = true;
        }
      }
    }

    return response;
  }

  loadLicenseCategories = (isMountCall) => {

    this.updateStateIfMounted({licencesLoading: true, licenseDisplayGroups: []});
    getLicenceCategories(this.props.configuration.softwareSelection, this.props.configuration.licenseModel).then((response) => {
      const availableSelectorIds = this.extractAvailableSelectorIds(response.licenseDisplayGroups);
      const scopedLicences = {};
      const availableLicenseModel = {};

      for (const scopedLicense of (response.scopedLicenses || [])) {
        scopedLicences[scopedLicense.id] = true;
        if (scopedLicense.licenseModel) {
          availableLicenseModel[scopedLicense.licenseModel] = true;
        }
      }

      this.updateStateIfMounted({licenseDisplayGroups: response.licenseDisplayGroups,
        scopedLicences, availableLicenseModel,
        mobileSelectedLicenseDisplayGroup: response.licenseDisplayGroups?.[0]?.displayGroupKey
      });

      const knowMoreReferences = [];
      // Build the know more links
      for (const comparatorType of response?.licenseDisplayGroups?.flatMap(displayGroup => (displayGroup.subGroups || [])).flatMap(subGroup => (subGroup.comparatorTypes || []))) {
        if (comparatorType.scopedKnowMoreReferences?.length > 0) {
          knowMoreReferences.push(comparatorType.scopedKnowMoreReferences[0].id);
        }
      }
      getKnowMoreLinks(knowMoreReferences).then((knowMoreLinksMap) => {
        this.updateStateIfMounted({knowMoreLinksMap});
      }).catch(() => {});

      if (isMountCall) {
        // Add automatically licences from the call by range
        const cbrReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];
        const referencesToAdd = cbrReferences.filter(value => scopedLicences[value] === true);

        if (referencesToAdd.length > 0) {
          this.addSoftwareLicences(referencesToAdd.map((licence) => { return {id: licence, quantity: 1};}), 'auto');
        }

        if (availableSelectorIds[appConfiguration.licenseSelectorId]) {
          this.openSelectorModal(appConfiguration.licenseSelectorId, [], scopedLicences);
          unsetLicenseSelectorId();
        }

        this.props.resetCallByRangeSelectedItems();
      }
    }).finally(() => {
      this.updateStateIfMounted({licencesLoading: false});
    });
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;
    this.loadLicenseCategories(true);
    if (this.props.configuration.status === configurationStatuses.finished && (this.props.configuration.outdatedLicenses || []).length > 0) {
      // Ask for license migration
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
            this.props.setActiveStep(stepsConfig.service_plan);
          },
          onSubmit: () => {
            this.props.closeModal();
            this.props.updateMsxSoftwareLicenseReferences(this.props.configuration);
          },
          title: I10n.get('screen.licence_selector.outdated_licences.modal.title'),
          text: this.buildOutdatedLicensesModalContent(),
          cancelText: I10n.get('app.action.no'),
          submitText: I10n.get('app.action.yes')
        }
      });
    }

    this._selectedDisplayGroupChecker = setInterval(() => {
      if (this.state.licenseDisplayGroups?.length > 0) {
        let selectedDisplayGroup = this.state.licenseDisplayGroups[0];
        for (const displayGroup of this.state.licenseDisplayGroups) {
          const elt = document.getElementById(`plc-display-groups-${displayGroup.displayGroupKey}`);
          if (elt && (elt.getBoundingClientRect().top + 300) < window.innerHeight) {
            selectedDisplayGroup = displayGroup;
          }
        }

        if (selectedDisplayGroup?.displayGroupKey !== this.state.selectedDisplayGroup) {
          this.updateStateIfMounted({selectedDisplayGroup: selectedDisplayGroup.displayGroupKey});
        }
      }
    }, 200);
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    if (this._selectedDisplayGroupChecker) {
      clearInterval(this._selectedDisplayGroupChecker);
    }
    this._isMounted = false;
    this.props.closeModal();
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  buildOutdatedLicensesModalContent = () => {
    return (<OutdatedLicenseModalContentWrapper>
      <OutdatedLicenseModalLabel>
        {I10n.get('screen.licence_selector.outdated_licences.modal.body')}
      </OutdatedLicenseModalLabel>
      {this.props.configuration.outdatedLicenses.map((outdatedItem, idx) => {
        if (outdatedItem.outdatedType === SUBSTITUTION_TYPE_REPLACE) {
          return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplaceMultiple('screen.licence_selector.outdated_licences.modal.updated', [outdatedItem.oldLicense, outdatedItem.newLicense])}</OutdatedLicenseModalRowLabel>;
        }
        return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplace('screen.licence_selector.outdated_licences.modal.removed', outdatedItem.oldLicense)}</OutdatedLicenseModalRowLabel>;
      })}
    </OutdatedLicenseModalContentWrapper>);
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  removeSoftwareLicence = (licence, cancelCallback) => {
    this.showDuplicateConfirmationModal(() => {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { if (cancelCallback) { cancelCallback(); } this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            this.props.removeSoftwareLicence(licence).then(() => {
              if (this.props.configuration.softwareLicences.length === 0) {
                this.updateStateIfMounted({showPackageSummary: false});
              }
            });
          },
          title: I10n.get('screen.licence_selector.remove_licence.modal.title'),
          text: I10n.get('screen.licence_selector.remove_licence.modal.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    });
  }

  toggleLicenseModel(newLicenseModel) {
    this.showDuplicateConfirmationModal(() => {
      if (this.props.configuration.softwareLicences.length > 0) {
        this.props.openModal({
          modalType: 'confirmation',
          modalProps: {
            onCancel: () => { this.props.closeModal(); },
            onSubmit: () => {
              this.props.closeModal();
              this.props.setLicenseModel(newLicenseModel).then(() => {
                this.loadLicenseCategories(false);
              });
            },
            title: I10n.get('screen.licence_selector.switch_license_model_modal_clear.title'),
            text: I10n.get('screen.licence_selector.switch_license_model_modal_clear.body'),
            cancelText: I10n.get('app.action.cancel'),
            submitText: I10n.get('app.action.continue'),
          }
        });
      } else {
        this.props.setLicenseModel(newLicenseModel).then(() => {
          this.loadLicenseCategories(false);
        });
      }
    });
  }

  renderLicenseModelButtons = (size) => {
    return (
      <>
        <LicenseModelButtonWrapper>
          <Button
            id="perpetual-license-model-button"
            size={size}
            disabled={this.props.configurationSaver.isSaving}
            importance={this.props.configuration.licenseModel === LICENSE_MODELS.PERPETUAL ? 'emphasized' : 'standard'}
            onClick={(event) => {
              event.preventDefault();
              if (this.props.configuration.licenseModel !== LICENSE_MODELS.PERPETUAL) {
                this.toggleLicenseModel(LICENSE_MODELS.PERPETUAL);
              }
            }}
          >
            {I10n.get('screen.licence_selector.license_model.perpetual')}
          </Button>

        </LicenseModelButtonWrapper>
        <LicenseModelButtonWrapper>
          <Button
            id="subscription-license-model-button"
            size={size}
            disabled={this.props.configurationSaver.isSaving}
            importance={this.props.configuration.licenseModel === LICENSE_MODELS.SUBSCRIPTION ? 'emphasized' : 'standard'}
            onClick={(event) => {
              event.preventDefault();
              if (this.props.configuration.licenseModel !== LICENSE_MODELS.SUBSCRIPTION) {
                this.toggleLicenseModel(LICENSE_MODELS.SUBSCRIPTION);
              }
            }}
          >
            {I10n.get('screen.licence_selector.license_model.subscription')}
          </Button>
        </LicenseModelButtonWrapper>
      </>
    );
  }

  renderLicenseModelToggle = () => {

    return (
      <LicenseModelWrapper>
        <MobileLicenseModelButtonsWrapper>
          {this.renderLicenseModelButtons('standard')}
        </MobileLicenseModelButtonsWrapper>
        <LicenseModelButtonsWrapper>
          {this.renderLicenseModelButtons('large')}
        </LicenseModelButtonsWrapper>
        <Link onClick={() => {
          this.props.openModal({
            modalType: 'compare-license-models',
            modalProps: {
              softwareSelection: this.props.configuration.softwareSelection
            }
          });
        }}>{I10n.get('screen.licence_selector.how_are_they_different')}</Link>
      </LicenseModelWrapper>
    );
  }

  renderMainSection = () => {
    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <LicenceSelectorScreenV2Content
          softwareSelection={this.props.configuration.softwareSelection}
          licenseDisplayGroups={this.state.licenseDisplayGroups}
          onAddSoftwareLicencesRequested={this.onAddSoftwareLicencesRequested}
          knowMoreLinksMap={this.state.knowMoreLinksMap}
          licencesLoading={this.state.licencesLoading}
          mobileSelectedLicenseDisplayGroup={this.state.mobileSelectedLicenseDisplayGroup}
          isSaving={this.props.configurationSaver.isSaving}

        ></LicenceSelectorScreenV2Content>
      </ContentWrapper>
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  hasActiveCBRFilters = () => {
    return (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length > 0) ||
      (this.props.callByRangeReducer?.selectedItems?.ranges && Object.keys(this.props.callByRangeReducer?.selectedItems?.ranges).length > 0);
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => {
        if (this.hasActiveCBRFilters()) {
          this.props.openModal({
            modalType: 'confirmation',
            modalProps: {
              onCancel: () => { this.props.closeModal(); },
              onSubmit: () => {
                this.props.closeModal();
                if (configurationStatuses.finished === config.status) {
                  this.props.setActiveStep(softwareStepsConfig.software_selection);
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.software_selection).then(() => {
                  }).catch(() => { });
                }
              },
              title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
              text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
              cancelText: I10n.get('app.action.no'),
              submitText: I10n.get('app.action.yes'),
            }
          });
        } else {
          if (configurationStatuses.finished === config.status) {
            this.props.setActiveStep(softwareStepsConfig.software_selection);
          } else {
            this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.software_selection).then(() => {
            }).catch(() => { });
          }
        }
      }, active: true, done: true },
      { action: () => {}, active: false, done: isSaved },
      {
        action: () => {

          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(softwareStepsConfig.service_plan);
          } else {
            this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.service_plan).then(() => {
            }).catch(() => { });
          }
        },
        active: this.props.configuration.softwareLicences?.length > 0, done: isSaved,
        hidden: this.props.configuration.servicePlanItems?.length === 0
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.save_screen);
          } else {
            this.props.saveConfiguration(this.props.configuration).then(() => {
              this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
            }).catch(() => { });
            this.props.closeModal();
          }
        }, active: this.props.configuration.softwareLicences?.length > 0 , done: isSaved
      },
    ];
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  clearCBRCategory = (category) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: () => {
          const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
          if (newValue.selectedItems[category]) {
            newValue.selectedItems[category] = {};
          }
          this.props.setCallByRangeSelectedItems(newValue);
          logDeleteCBRFilterEvent(this.props.configuration?.id, softwareStepsConfig.licence_selector, category);
          this.props.closeModal();
        },
        title: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.title'),
        text: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.apply'),
      }
    });
  }

  renderScreenContent = () => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <MainContentWrapper ref={this.setWrapperRef}>
            {this.renderMainSection()}
          </MainContentWrapper>
        </ScreenContent>
      </>
    );
  }

  computeLicenseLevel = () => {
    let result;
    for (let i = 0; i < (this.props.configuration?.softwareLicences || []).length && result == null ; i++) {
      const softwareLicence = this.props.configuration?.softwareLicences[i];
      if (softwareLicence.licenseLevel != null) {
        result = softwareLicence.licenseLevel;
      }
    }

    return result;
  }

  openSelectorModal = (licenceType, startCriterias, scopedLicences) => {
    this.props.openModal({
      modalType: 'software-licence-selector',
      modalProps: {
        softwareLicences: this.props.configuration.softwareLicences,
        softwareSelection: this.props.configuration.softwareSelection,
        scopedLicences: scopedLicences,
        availableLicenseModel: this.state.availableLicenseModel,
        licenceType,
        startCriterias,
        licenseModel: this.props.configuration.licenseModel,
        licenseLevel: this.computeLicenseLevel(),
        onSubmit: (licencesToAdd, withNavigation) => {
          if (withNavigation) {
            this.addSoftwareLicencesWithNavigation(licencesToAdd, licenceType);
          } else {
            this.addSoftwareLicences(licencesToAdd, licenceType);
          }
          this.props.closeModal();
        }
      }
    });
  }

  addSoftwareLicencesWithNavigation = (licencesToAdd, selectorOrigin) => {
    this.props.addSoftwareLicencesWithNavigation(licencesToAdd, selectorOrigin);
  }

  addSoftwareLicences = (licencesToAdd, selectorOrigin) => {
    this.props.addSoftwareLicences(licencesToAdd, selectorOrigin).then(() => {
      if (licencesToAdd.length >= 1) {
        this.props.showNotification(I10n.get('screen.licence_selector.notification.licences_added'), 'success', null);
      }
    });
  }

  onAddSoftwareLicencesRequested = (type) => {
    this.showDuplicateConfirmationModal(() => {
      this.openSelectorModal(type.licenseTypesKey, type.startCriterias, this.state.scopedLicences);
    });
  }

  onContinue = () => {
    if (this.props.configuration.servicePlanItems?.length > 0) {
      if (configurationStatuses.finished === this.props.configuration.status) {
        this.props.setActiveStep(softwareStepsConfig.service_plan);
      } else {
        this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.service_plan)
          .then(() => {})
          .catch(() => {});
        this.props.closeModal();
      }

    } else {
      if (configurationStatuses.finished === this.props.configuration.status) {
        this.props.setActiveStep(stepsConfig.save_screen);
      } else {
        this.props.saveConfiguration(this.props.configuration, softwareStepsConfig.service_plan).then(() => {
          this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
        }).catch(() => {
        });
        this.props.closeModal();
      }
    }
  }

  renderNavigationButtonSection = () => {
    const buttons = <>
      <CancelWrapper>
        <Button
          id='license-selector-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={event => {
            this.props.setActiveStep(softwareStepsConfig.software_selection);
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {this.props.configuration.softwareLicences?.length > 0 && <Button
        importance="emphasized"
        primary
        disabled={this.props.configurationSaver.isSaving || this.props.configuration.softwareLicences?.length === 0}
        onClick={event => {
          this.onContinue();
        }}>
        {I10n.get('app.action.continue')}
      </Button>}

    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          {buttons}
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  // To be removed
  showNotification = (notificationText) => {
    this.updateStateIfMounted({showNotification: true, notificationText});
    setTimeout(() => { this.hideNotification(); }, 10000);
  }

  // To be removed
  hideNotification = () => {
    this.updateStateIfMounted({showNotification: false});
  }

  renderDisplayGroupTitle = (displayGroup, onClickCallback, selected) => {
    return (
      <DisplayGroupItem key={displayGroup.displayGroupKey} onClick={onClickCallback}>
        <DisplayGroupLabel $selected={selected}>
          {I10n.getOrDefault(`screen.licence_selector.display_group.name.${displayGroup.labelKey}`, displayGroup.displayGroupName)}
        </DisplayGroupLabel>
        <SelectionBar $selected={selected}></SelectionBar>
      </DisplayGroupItem>
    );
  }

  render = () => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const licensesToShow = [...this.props.configuration.softwareLicences]
      .map(license => {return {
          ...license,
          canRemove: true,
          quantityLabel: I10n.get('bom.qty')
        };
      })
      .sort((a,b) => a.order - b.order);

    if (this.props.configuration.servicePlanActivated) {
      licensesToShow.push(...[...this.props.configuration.servicePlanItems].map(servicePlanItem => {
        return {
          ...servicePlanItem,
          quantityLabel: I10n.get('bom.service_plan_size'),
          ignoreGlobalQuantity: true
        };
      }));
    }

    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.licence_selector.title')}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getSoftwareStepperLabels()}
          activeStep={softwareStepsConfig.licence_selector}
          stepperActions={this.getStepperActions(isSaved)}
          selectedCriteria={this.props.callByRangeReducer?.selectedItems || {}}
          clearCategory={this.clearCBRCategory}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={true}
        ></ApplicationFullHeader>
        <TitleAndModelWrapper>
          <Notification>
          </Notification>
          <StepTitle>{I10n.get(`screen.licence_selector.${this.props.configuration.softwareSelection}.title`)}</StepTitle>
          {(window.top === window.self && this.state.availableLicenseModel[LICENSE_MODELS.SUBSCRIPTION] === true) && <>
            <StepSubtitle>{I10n.get('screen.licence_selector.subscription_mode.subtitle')}</StepSubtitle>
            {this.renderLicenseModelToggle()}
          </>}
          <DesktopDisplayGroupTitlesWrapper>
            {this.state.licenseDisplayGroups.map((displayGroup) => {
              return (
                this.renderDisplayGroupTitle(displayGroup, () => {
                  const element = document.getElementById(`plc-display-groups-${displayGroup.displayGroupKey}`);
                  if (element == null) {
                    return;
                  }

                  let headerOffset = 0;
                  // The Schneider Electric headers are hiding
                  if (appConfiguration.seamlessSession) {
                    const candidateHeaders = [...document.getElementsByClassName('se-header-wraper')];
                    if (candidateHeaders.length > 0) {
                      headerOffset = candidateHeaders[0].getBoundingClientRect().height;
                    }
                  } else if (document.getElementById('sdl-header')) {
                    headerOffset = document.getElementById('sdl-header').getBoundingClientRect().height;
                  }

                  if (appConfiguration.launchFromScript && !this.props.applicationParameters.fullScreenEnabled) {
                    const element = document.getElementById(`plc-display-groups-${displayGroup.displayGroupKey}`)
                    const y = element.getBoundingClientRect().top + window.scrollY - headerOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                  } else if (this._scrollComponent != null) {
                    this._scrollComponent.scrollTo({
                      top:  element.offsetTop,
                      behavior: "smooth",
                    });
                  }


                }, this.state.selectedDisplayGroup === displayGroup.displayGroupKey));
            })}
          </DesktopDisplayGroupTitlesWrapper>
          <MobileDisplayGroupTitlesWrapper>
            {this.state.licenseDisplayGroups.map((displayGroup) => {
              return (
                this.renderDisplayGroupTitle(displayGroup, () => {
                  this.updateStateIfMounted({mobileSelectedLicenseDisplayGroup: displayGroup.displayGroupKey});
                }, this.state.mobileSelectedLicenseDisplayGroup === displayGroup.displayGroupKey));
            })}
          </MobileDisplayGroupTitlesWrapper>
          {this.props.configuration.softwareLicences.length > 0 && <LicenseBomButton onClick={() => { this.updateStateIfMounted({showPackageSummary: true});}}>
              <MsxIcons name={"new-project"}></MsxIcons>
              <BomButtonLabel>{I10n.get('app.action.go_to_bom')}</BomButtonLabel>
          </LicenseBomButton>}
        </TitleAndModelWrapper>
        <ApplicationWrapper ref={(element) => {this._scrollComponent = element;}} id="slc-license-groups-scrollable-wrapper">
          <PackageSummaryPositionner $show={this.state.showPackageSummary}>
            <PackageSummaryBackground $show={this.state.showPackageSummary} onClick={() => { this.updateStateIfMounted({showPackageSummary: false});}}/>
            <PackageSummaryWrapper $show={this.state.showPackageSummary}>
              <LicenseSelectorPackageSummary
                licenseGroups={buildLicenseGroups(licensesToShow)}
                licenseModel={this.props.configuration.licenseModel}
                availableLicenseModels={this.props.configuration.softwareInfo?.availableLicenseModels || []}
                removeSoftwareLicence={this.removeSoftwareLicence}
                onClear={() => {
                  this.props.openModal({
                    modalType: 'confirmation',
                    modalProps: {
                      onCancel: () => { this.props.closeModal(); },
                      onSubmit: () => {
                        this.props.clearSoftwareLicenses().then(() => {
                          this.props.closeModal();
                          this.updateStateIfMounted({showPackageSummary: false});
                        });
                      },
                      title: I10n.get('screen.licence_selector.switch_license_model_modal_clear.title'),
                      text: I10n.get('screen.licence_selector.switch_license_model_modal_clear.body'),
                      cancelText: I10n.get('app.action.cancel'),
                      submitText: I10n.get('app.action.continue'),
                    }
                  });
                }}
                onClose={() => {
                  this.updateStateIfMounted({showPackageSummary: false});
                }}
                disabled={this.props.configurationSaver.isSaving}
                actionButtons={[{
                  action: () => {
                    this.onContinue();
                  },
                  importance: 'emphasized',
                  label: I10n.get('app.action.continue')
                }]}
              />
            </PackageSummaryWrapper>
          </PackageSummaryPositionner>
          {this.renderScreenContent()}
        </ApplicationWrapper>
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {

  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    addSoftwareLicences: (licencesWithQuantity, selectorOrigin) => dispatch(addSoftwareLicences(licencesWithQuantity, selectorOrigin)),
    addSoftwareLicencesWithNavigation: (licencesWithQuantity, selectorOrigin) => dispatch(addSoftwareLicencesWithNavigation(licencesWithQuantity, selectorOrigin)),
    removeSoftwareLicence: (licence) => dispatch(removeSoftwareLicence(licence)),
    setLicenseModel: (newLicenseModel) => dispatch(setLicenseModel(newLicenseModel)),
    setSoftwareLicenceQuantity: (licence, newQuantity) => dispatch(setSoftwareLicenceQuantity(licence, newQuantity)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    updateMsxSoftwareLicenseReferences: (config) => dispatch(updateMsxSoftwareLicenseReferences(config)),
    clearSoftwareLicenses: () => dispatch(clearSoftwareLicenses())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenceSelectorScreenV2);
